// фото стоянок
import React from 'react';
import {
  CTabPane,
  CButton,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell
} from '@coreui/react';
import PhotoParkingModal from './PhotoParkingModal';

const PhotoTab = ({
  // Убираем неиспользуемые пропсы
  // isLoading: initialLoading,
  // photoItems,
  idProtocol
}) => {
  const [modalState, setModalState] = React.useState(false);
  const [name, setName] = React.useState('');
  const [filePath, setFilePath] = React.useState('');
  const [photoItems, setPhotoItems] = React.useState([]);
  // Инициализируем состояние загрузки как false, так как PhotoTab управляет им самостоятельно
  const [loading, setLoading] = React.useState(false);
  const [selectedPhotoId, setSelectedPhotoId] = React.useState(null);

  // Эффект для загрузки данных при изменении idProtocol
  React.useEffect(() => {
    if (idProtocol) {
      fetchPhotoItems(idProtocol);
    } else {
      // Если idProtocol стал null (например, при закрытии модалки без сохранения),
      // очищаем список и состояние
      setPhotoItems([]);
      setLoading(false);
    }
  }, [idProtocol]); // Зависимость только от idProtocol

  const fetchPhotoItems = async (idProtocol) => {
    setLoading(true);
    const token = localStorage.getItem("token");
    if (!token) {
        console.error('Токен авторизации не найден');
        setPhotoItems([]);
        setLoading(false);
        return;
    }
    try {
      const response = await fetch(`/api/typetable/?id_parent=${idProtocol}&ntype=23`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`Ошибка загрузки данных: ${response.status}`);
      }

      const data = await response.json();
      setPhotoItems(data || []);
    } catch (error) {
      console.error('Ошибка при загрузке фото:', error);
      setPhotoItems([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setName('');
    setFilePath('');
    setSelectedPhotoId(null);
    setModalState(true);
  };

  const handleEdit = () => {
    if (!selectedPhotoId) {
      alert("Выберите запись для изменения");
      return;
    }

    const selectedItem = photoItems.find(item => item.Id === selectedPhotoId);
    if (!selectedItem) {
      alert("Выбранная запись не найдена");
      return;
    }

    setName(selectedItem.NParam || '');
    setFilePath(selectedItem.FileName || '');
    setModalState(true);
  };

  const handleSaveFromModal = async (data) => {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("Не найден токен авторизации");
      return;
    }

    const isEditMode = selectedPhotoId !== null;

    try {
      const response = await fetch('/api/typetable/', {
        method: isEditMode ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(
          isEditMode
            ? {
                Id: selectedPhotoId,
                file_name: data.filePath,
                nparam: data.name
              }
            : {
                id_parent: idProtocol,
                file_name: data.filePath,
                ntype: 23,
                nparam: data.name
              }
        )
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Ошибка: ${response.status} - ${errorText}`);
      }

      const result = await response.json();
      alert(isEditMode ? 'Фото успешно обновлено' : 'Фото успешно добавлено');
      setModalState(false);
      setSelectedPhotoId(null);
      // После сохранения перезагружаем список фото
      await fetchPhotoItems(idProtocol);
    } catch (error) {
      console.error('Ошибка при сохранении:', error);
      alert('Ошибка: ' + error.message);
    }
  };

  const handleDelete = async () => {
    if (!selectedPhotoId) {
      alert("Выберите запись для удаления");
      return;
    }

    if (!window.confirm("Вы уверены, что хотите удалить эту запись?")) {
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      alert("Не найден токен авторизации");
      return;
    }

    try {
      const response = await fetch(`/api/typetable/`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ Id: selectedPhotoId })
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Ошибка удаления: ${response.status} - ${errorText}`);
      }

      setSelectedPhotoId(null);
      // После удаления перезагружаем список фото
      await fetchPhotoItems(idProtocol);
      alert('Запись успешно удалена');
    } catch (error) {
      console.error('Ошибка при удалении фото:', error);
      alert('Не удалось удалить запись: ' + error.message);
    }
  };

  const handleRowClick = (item) => {
    setSelectedPhotoId(item.Id);
  };

  return (
    <>
      <CTabPane visible={true}>
        <div className="mb-3 d-flex gap-2">
          <CButton color="secondary" onClick={handleAdd}>Добавить</CButton>
          <CButton color="secondary" onClick={handleEdit}>Изменить</CButton>
          <CButton color="danger" onClick={handleDelete}>Удалить</CButton>
        </div>

        <CTable bordered hover>
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell>№ п/п</CTableHeaderCell>
              <CTableHeaderCell>Описание</CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {loading ? (
              <CTableRow>
                <CTableDataCell colSpan={2} className="text-center">Загрузка...</CTableDataCell>
              </CTableRow>
            ) : photoItems.length === 0 ? (
              <CTableRow>
                <CTableDataCell colSpan={2} className="text-center">Нет данных</CTableDataCell>
              </CTableRow>
            ) : (
              photoItems.map((item, index) => (
                <CTableRow
                  key={item.Id}
                  onClick={() => handleRowClick(item)}
                  style={{ cursor: 'pointer' }}
                >
                  <CTableDataCell
                    style={{ backgroundColor: selectedPhotoId === item.Id ? "#66A7F2" : "" }}
                  >
                    {index + 1}
                  </CTableDataCell>
                  <CTableDataCell
                    style={{ backgroundColor: selectedPhotoId === item.Id ? "#66A7F2" : "" }}
                  >
                    {item.NParam || '-'}
                  </CTableDataCell>
                </CTableRow>
              ))
            )}
          </CTableBody>
        </CTable>
      </CTabPane>

      <PhotoParkingModal
        visible={modalState}
        onClose={() => {
          setModalState(false);
          setSelectedPhotoId(null);
        }}
        onSave={handleSaveFromModal}
        name={name}
        setName={setName}
        filePath={filePath}
        setFilePath={setFilePath}
        isEditMode={selectedPhotoId !== null}
      />
    </>
  );
};

export default PhotoTab;